export default __webpack_public_path__ + "static/media/chevero-down-grey.9153ab9c.svg";